import { createSlice } from "@reduxjs/toolkit";

export const UsersSlice = createSlice({
    name: 'Users',
    initialState: [],
    reducers: {
        emptyUsers: state => {
            return []
        },
        setUsers: (state, action) => {
            if (Array.isArray(action?.payload)) {
                return action.payload
            }
        },
        add: (state, action) => {
            // return [...state, ...action.payload]
            return []
        },
        // Merges the payload into the record with the same id (the PUT answers may carry only some fields); no
        // record with that id, nothing changes.
        update: (state, action) => {
            const payload = action?.payload;
            if (payload?.id === undefined || payload?.id === null) return state;
            const foundedIndex = state.findIndex((user) => String(user.id) === String(payload.id));
            if (foundedIndex !== -1) {
                state[foundedIndex] = { ...state[foundedIndex], ...payload }
            }
            return state
        },
        removeUsers: (state, action) => {
            const foundedIndex = state?.findIndex((user) => user.id === action?.payload?.id);
            if (foundedIndex !== -1) {
                state.splice(foundedIndex, 1)
                return state;
            }
            throw new Error('Index to remove not found')
        },
        // removeUsersByClientName: (state, action) => {
        //     const foundedIndex = state?.findIndex((user) => user.id === action?.payload?.client_name);
        //     if (foundedIndex !== -1) {
        //         state.splice(foundedIndex, 1)
        //         return state;
        //     }
        //     throw new Error('Index to remove not found')
        // }
    }
});

export const {
    setUsers, 
    emptyUsers,
    update,
    removeUsers,
    add
} = UsersSlice.actions;

export default UsersSlice.reducer
